import { z } from "zod";
import { MATCH_OFFICIAL_ROLES } from "../types/match-official.js";

export const matchOfficialEntrySchema = z.object({
  role: z.enum(MATCH_OFFICIAL_ROLES),
  name: z.string().min(1, "Official name is required").max(255),
  boksmart_number: z.string().max(64).nullish(),
});

export const upsertMatchOfficialsSchema = z
  .object({
    officials: z.array(matchOfficialEntrySchema).max(10),
  })
  .refine((d) => d.officials.filter((o) => o.role === "referee").length <= 1, {
    message: "Only one referee allowed",
    path: ["officials"],
  });

export type MatchOfficialEntryInput = z.infer<typeof matchOfficialEntrySchema>;
export type UpsertMatchOfficialsInput = z.infer<typeof upsertMatchOfficialsSchema>;
